import axios from '../api/axiosInstance';

export const fetchBrands = (params) => {
  return axios.get('/product-brands', { params });
};

export const createBrand = (data) => {
  return axios.post('/product-brands', data);
};

export const updateBrand = (id, data) => {
  return axios.put(`/product-brands/${id}`, data);
};

export const updateBrandStatus = (id, status) => {
  return axios.patch(`/product-brands/${id}/status`, { status });
};

export const deleteBrand = (id) => {
  return axios.delete(`/product-brands/${id}`);
};

